import {
  bootstrapConsentProvider,
  hasConsentBeenGiven,
} from '@otto-ec/eprivacy-onetrust-sdk'
import { OnetrustCookieBanner, PreferenceCenterTracking } from './core'
import {
  ElementsClickObserver,
  ElementsEventObserver,
  ElementsExistsObserver,
  ElementsScrollObserver,
  ElementsVisibleObserver,
  ObserverService,
} from './adapters'
import {
  broadcaster,
  CONSENT_CHANGED_BROADCAST_EVENT,
  isApp,
  showConsentBannerUseCase,
} from '@otto-ec/eprivacy-shared'
import {
  ElementsClickObserverPort,
  ElementsEventObserverPort,
  ElementsExistsObserverPort,
  ElementsScrollObserverPort,
  ElementsVisibleObserverPort,
  MutationObserverFactory,
  ObserverPort,
} from './ports'
import { Result } from '@otto-ec/eprivacy-measures'
import { measureInit } from './singletons/measure-init.singleton'
import { trackingService } from './singletons/tracking-service.singleton'
import { __oneTrustSdkReady } from '@otto-ec/eprivacy-cmp'

declare global {
  /*                                 */
  interface Window {
    cookieBanner: OnetrustCookieBanner
    o_cookieBanner: OnetrustCookieBanner
  }
}
export const bootstrap = async () => {
  await measureInit.startLoad()

  const consentProvider = await bootstrapConsentProvider()
  if (!consentProvider) {
    measureInit.endLoad(Result.CbLoadError)
    return
  }

  const mutationObserverFactory: MutationObserverFactory = {
    create: (callback: MutationCallback) => new MutationObserver(callback),
  }
  const observerPort: ObserverPort = new ObserverService(
    mutationObserverFactory
  )

  const elementsExistsObserver: ElementsExistsObserverPort =
    new ElementsExistsObserver(document, observerPort)
  const elementsEventObserver: ElementsEventObserverPort =
    new ElementsEventObserver(document, elementsExistsObserver)
  const elementsClickObserver: ElementsClickObserverPort =
    new ElementsClickObserver(elementsEventObserver)
  const elementsScrollObserver: ElementsScrollObserverPort =
    new ElementsScrollObserver(elementsEventObserver)
  const elementsVisibleObserver: ElementsVisibleObserverPort =
    new ElementsVisibleObserver(elementsExistsObserver)

  const pcTracking = new PreferenceCenterTracking(
    elementsVisibleObserver,
    trackingService
  )
  pcTracking.registerViewTrackingListener()

  const onetrustCookieBanner = new OnetrustCookieBanner(
    document,
    elementsClickObserver,
    elementsScrollObserver,
    elementsVisibleObserver,
    trackingService,
    measureInit
  )

  onetrustCookieBanner.registerEventListener()
  onetrustCookieBanner.registerLinkTrackingListener()

  const isShown = showConsentBannerUseCase.run()

  if (!isApp()) {
    broadcaster.receive(CONSENT_CHANGED_BROADCAST_EVENT, () => {
      void showConsentBannerUseCase.hideInitial()
    })
  }

  if (!isShown || hasConsentBeenGiven()) {
    measureInit.endLoad(Result.CBHidden)
  }

  /*                                                                    */
  /*                                                               */
  __oneTrustSdkReady.emit({ retain: true })
}
